import { trackGoogleAnalytics } from './sendGa';

export function trackVisit(page: string) {
    trackGoogleAnalytics({
        ec: 'page',
        ea: 'visit',
        el: page,
    });
}

export function trackClick(name: string) {
    trackGoogleAnalytics({
        ec: 'button',
        ea: 'click',
        el: name,
    });
}

